import { render, staticRenderFns } from "./epicor.list.vue?vue&type=template&id=c1f66298&scoped=true&"
import script from "./epicor.list.vue?vue&type=script&lang=ts&"
export * from "./epicor.list.vue?vue&type=script&lang=ts&"
import style0 from "./epicor.list.vue?vue&type=style&index=0&id=c1f66298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f66298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
